import React from "react";
import styles from "./Technical.module.css";

const stackLines = [
  { key: "languages", value: "TypeScript, Python, Swift, React Native" },
  { key: "ai/agents", value: "Claude Code, OpenAI Codex, OpenClaw, MCP, LangChain" },
  { key: "frontend", value: "React, Next.js, React Native, Redux, Tailwind" },
  { key: "backend", value: "Node.js, Express.js, FastAPI, REST APIs" },
  { key: "database", value: "MongoDB, PostgreSQL, Firebase, Supabase, PlanetScale" },
  { key: "infra", value: "Vercel, AWS, GitHub Actions, Docker" },
];

function Technical() {
  return (
    <section className={styles.section} style={{ opacity: 0, animation: "fadeIn 0.6s ease-out 0.4s forwards" }}>
      <h2 className={styles.heading}>Technical</h2>
      <div className={styles.terminal}>
        <div className={styles.dots}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dirLabel}>~/ashish</span>
        </div>
        <div className={styles.body}>
          <p className={styles.commandLine}>
            <span className={styles.prompt}>$</span> cat stack.txt
          </p>
          <div className={styles.output}>
            {stackLines.map((line, i) => (
              <p key={i}>
                <span className={styles.key}>{line.key}:</span> {line.value}
              </p>
            ))}
          </div>
          <p className={styles.commandLine} style={{ paddingTop: "4px" }}>
            <span className={styles.prompt}>$</span>{" "}
            <span className={styles.cursor}></span>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Technical;
